import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoCountDown from 'eco-design/elements/eco-count-down';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.ActivityA1');
    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <div className="common-page-desc">
                <span className="page-section-timer-icon"></span>
                {t('desc')}
            </div>
            <div className="common-page-countdown">
                <div className="common-page-countdown-l">終了まであと: </div>
                <EcoCountDown
                    endTime={'2025/05/07 23:00:00 GMT+8'}
                    className="common-page-countdown-r"
                    tipsDay="日"
                    tipsHour="時"
                    tipsMinute="分"
                    tipsSecond="秒"
                />
            </div>
        </div>
    );
}
